import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SettingsService } from '../_services';

@Injectable()
export class OrderDeliverySettingsCardResolve implements Resolve<any> {

  constructor( private _settingsService: SettingsService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this._settingsService.getOrderDeliverySettings();
  }
}